import React, { Component } from "react";
import {useHistory } from "react-router-dom";
import StoreContext from "./../../../Store/Context";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { Row, Col, Container, Button, Label } from "reactstrap";
import { COLUMNS_GRADES, EXPAND_ROW_GRADE } from "../../Constants/DatatableColumns";
import { PENCIL } from "../../Constants/SrcImages";
import {validateTokenStorage} from './../../Constants/Util';
import { AdminModalImport, AdminModalRegistration, AdminModalChangeGrade, AdminModalRemoveStudent,ModalListaPerson } from "./../../Constants/Modal";
import {
  getPersonListEstAcu,
  getSetup,
  getPersonByCedula,
  getGrades,
  getRegistration,
  getRegistrationYear,
  putRemoveRegister,
  postNewRegister,
  putChangeGrade,
  getPersonByCedulaImport,
  fetchRegistrationLastYearByGrade,
  getPersonToEditRegistration,
  putRegister
} from "../../Constants/Services";
import moment from "moment";
import {
  ISetup,
  IRegistration,
  IGrades,
  IRegistrationYear,
  IFormNewRegistration,
  IFormRemoveRegistration,
  IFChangeRegistration,
  IPersonSelected,
  IPersonSelect,
  IPersonSelectedImport,
  IGradeSelected,
  IRegistrationImport,
} from "./../../Constants/Interfaces";

interface IRegistrationState {
  dataRegistration: IRegistration[];
  formDataImport: IRegistrationImport;
  dataRegistrationSelected: IRegistration;
  registrationy: IRegistrationYear;
  dataGrades: IGrades[];
  dataPersonEstudiante: IPersonSelect[];
  dataPersonAcudiente: IPersonSelect[];
  dataStudent: IPersonSelectedImport[];
  dataGradeSelected: IGradeSelected;
  dataGradeImport: IGradeSelected;
  personEstRegister: IPersonSelected;
  personAcuRegister: IPersonSelected;
  formNewRegistration: IFormNewRegistration;
  formChangeRegistration: IFChangeRegistration;
  formRemoveRegistration: IFormRemoveRegistration;
  isOpenModalAddRegistration: boolean;
  isOpenModalEditRegistration: boolean;
  isOpenModalImport: boolean;
  isOpenModalChange: boolean;
  isOpenModalRemove: boolean;
  msg_error: string;
  dataFormSetup: ISetup;
  msg_error2: string;
  loading: boolean;
  isOpenModalListaEst:boolean;
  isOpenModalListaAcu:boolean;
}

class Registration extends Component<RouteComponentProps<{}>, IRegistrationState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataRegistration: [],
      dataPersonEstudiante: [],
      dataPersonAcudiente: [],
      dataRegistrationSelected: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_lastname: "",
        per_status: "",
        per_birthday: "",
        reg_id: "",
        reg_new: "",
        reg_complete: "",
      },
      dataStudent: [],
      formDataImport: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_acudiente:"",
        reg_complete: "",
        reg_testpsico: "",
        reg_photo: "",
        reg_certnac: "",
        reg_certsal: "",
        reg_vacuna: "",
        reg_copyced: "",
        reg_plegal: "",
        reg_legalinfo: "",
        re_cfirmado: "",
        reg_oldyear: "",
        gr_id: "",
        gr_desc: "",
        gr_olddesc: "",
      },
      personEstRegister: {
        per_id: "",
        per_name: "",
      },
      personAcuRegister: {
        per_id: "",
        per_name: "",
      },
      dataGrades: [],
      dataGradeImport:{
        gr_id: "",
        gr_desc: "",
      },
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
      registrationy: {
        set_registrationy: "",
      },
      isOpenModalAddRegistration: false,
      isOpenModalEditRegistration: false,
      isOpenModalImport: false,
      isOpenModalChange: false,
      isOpenModalRemove: false,
      isOpenModalListaEst:false,
      isOpenModalListaAcu:false,
      formNewRegistration: {
        reg_id:"",
        reg_peridEst: "",
        reg_cedulaEst: "",
        reg_nameEst: "",
        reg_peridAc: "",
        reg_cedulaAc: "",
        reg_nameAc: "",
        reg_testpsico: false,
        reg_photo: false,
        reg_certnac: false,
        reg_certsal: false,
        reg_vacuna: false,
        reg_copyced: false,
        reg_plegal: "0",
        reg_legalinfo: "",
        re_cfirmado: "0",
      },
      formChangeRegistration: {
        per_id: "",
        per_name: "",
        per_lastname: "",
        per_cedula: "",
        gr_id: "",
        gr_desc: "",
      },
      dataFormSetup: {
        set_registrationy: "",
        set_aniolectivo: "",
        set_startpactivo: new Date().toString(),
        set_endpactivo: new Date().toString(),
        set_start_ft: new Date().toString(),
        set_end_ft: new Date().toString(),
        set_start_st: new Date().toString(),
        set_end_st: new Date().toString(),
        set_start_tt: new Date().toString(),
        set_end_tt: new Date().toString(),
        set_trimestre: "",
      },
      formRemoveRegistration: {
        reg_id: "",
        per_id: "",
        per_name: "",
        per_lastname: "",
        per_cedula: "",
        reg_reason: "",
      },
      msg_error: "",
      msg_error2: "",
      loading: false,
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchPersonEst = this.fetchPersonEst.bind(this);
    this.fetchPersonAc = this.fetchPersonAc.bind(this);
    this.fetchRegistration = this.fetchRegistration.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handleModalImport = this.handleModalImport.bind(this);
    this.handleAddRegitration = this.handleAddRegitration.bind(this);
    this.fetchRegistrationYear = this.fetchRegistrationYear.bind(this);
    this.setGradeChanged = this.setGradeChanged.bind(this);
    this.handleModalChange = this.handleModalChange.bind(this);
    this.handleModalRemove = this.handleModalRemove.bind(this);
    this.onChangeRemoveRegister = this.onChangeRemoveRegister.bind(this);
    this.handlePutRemoveRegister = this.handlePutRemoveRegister.bind(this);
    this.handlerPostRegistration = this.handlerPostRegistration.bind(this);
    this.onChangeNewRegistration = this.onChangeNewRegistration.bind(this);
    this.onChangeNewRegistrationCheck = this.onChangeNewRegistrationCheck.bind(this);
    this.handlerChangeGrade = this.handlerChangeGrade.bind(this);
    this.onChangeImportRegistration = this.onChangeImportRegistration.bind(this);
    this.setContractImport = this.setContractImport.bind(this);
    this.setGradeChangedImport = this.setGradeChangedImport.bind(this);
    this.fetchPersonEstImport = this.fetchPersonEstImport.bind(this);
    this.handlerPutImport = this.handlerPutImport.bind(this);
    this.studentHandleSelected = this.studentHandleSelected.bind(this);
    this.editRegistration = this.editRegistration.bind(this);
    this.handlerDataEditRegistration = this.handlerDataEditRegistration.bind(this);
    this.fetchPersonToEditRegistration = this.fetchPersonToEditRegistration.bind(this);
    this.handleEditRegitration = this.handleEditRegitration.bind(this);
    this.handlerPutRegistration = this.handlerPutRegistration.bind(this);
    this.fetchSetup = this.fetchSetup.bind(this);
    this.handlerOpenLista = this.handlerOpenLista.bind(this);
    this.handlerSetPerson = this.handlerSetPerson.bind(this);
    this.setPerson = this.setPerson.bind(this);
    this.handlerOpenListaAcu = this.handlerOpenListaAcu.bind(this);
    this.fetchPersonList = this.fetchPersonList.bind(this);
    this.handlerOpenPerson = this.handlerOpenPerson.bind(this);

  }

  async fetchRegistration({ gr_id, gr_desc }: IGradeSelected) {
    const response = await getRegistration(gr_id);
    this.setState({
      dataRegistration: response,
      dataGradeSelected: { gr_id, gr_desc },
      loading: false,
    });
  }

  async fetchPersonList() {
    const response = await getPersonListEstAcu();
    this.setState({
      dataPersonEstudiante: response.est,
      dataPersonAcudiente: response.acu,
    });
  }

  async getRegistrationLastYearByGrade(gr_id: string) {
    const response = await fetchRegistrationLastYearByGrade(gr_id);
    this.setState({
      dataStudent: response,
      loading: false,
    });
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
      loading: false,
    });
  }

  async fetchPersonEst(e: { key: string }) {
    const props = this.state.formNewRegistration;
    if (e.key === "Enter") {
      const response = await getPersonByCedula(props.reg_cedulaEst);
      if (response.matriculado === "si") {
        this.setState({
          msg_error: props.reg_cedulaEst + " ya esta matriculado",
          personEstRegister: {
            per_id: "",
            per_name: "",
          },
          loading: false,
        });
      } else {
        if (response.existe !== "no") {
          if (response[0].per_type === "3") {
            this.setState({
              personEstRegister: {
                per_id: response[0].per_id,
                per_name: response[0].per_name + ` ` + response[0].per_lastname,
              },
              loading: false,
              msg_error: "",
            });
          } else {
            this.setState({
              msg_error: "La persona debe ser un estudiante",
            });
          }
        } else {
          this.setState({
            msg_error: "No existe estudiante con esa cedula",
          });
        }
      }
    }
  }

  async fetchPersonEstImport(e: { key: string }) {
    const props = this.state.formDataImport;
    if (e.key === "Enter") {
      const response = await getPersonByCedulaImport(props.per_cedula);
      if (response.matriculado === "si") {
        this.setState({
          msg_error: props.per_cedula + " ya esta matriculado",
          formDataImport: {
            per_id: "",
            per_cedula: "",
            per_name: "",
            per_acudiente:"",
            reg_complete: "",
            reg_testpsico: "",
            reg_photo: "",
            reg_certnac: "",
            reg_certsal: "",
            reg_vacuna: "",
            reg_copyced: "",
            reg_plegal: "",
            reg_legalinfo: "",
            re_cfirmado: "",
            reg_oldyear: "",
            gr_id: "",
            gr_desc: "",
            gr_olddesc: "",
          },
          loading: false,
        });
      } else {
        if (response.existe !== "no") {
          this.setState({
            formDataImport: {
              per_id: response[0].per_id,
              per_cedula: response[0].per_cedula,
              per_name: response[0].per_name,
              per_acudiente: response[0].per_acudiente,
              reg_complete: response[0].reg_complete,
              reg_testpsico: response[0].reg_testpsico,
              reg_photo: response[0].reg_photo,
              reg_certnac: response[0].reg_certnac,
              reg_certsal: response[0].reg_certsalud,
              reg_vacuna: response[0].reg_vacuna,
              reg_copyced: response[0].reg_copyced,
              reg_plegal: response[0].reg_plegal,
              reg_legalinfo: response[0].reg_legalinfo,
              re_cfirmado: "0",
              reg_oldyear: response[0].reg_year,
              gr_id: response[0].gr_id,
              gr_desc: response[0].gr_desc,
              gr_olddesc: response[0].gr_desc,
            },
            loading: false,
            msg_error: "",
          });
        } else {
          this.setState({
            msg_error: "No existe estudiante con esa cedula",
          });
        }
      }
    }
  }

  async fetchPersonAc(e: { key: string }) {
    if (e.key === "Enter") {
      const response = await getPersonByCedula(this.state.formNewRegistration.reg_cedulaAc);

      if (response.existe !== "no") {
        if (response.matriculado === "si") {
          this.setState({
            msg_error2: "Esta cedula es de un estudiante",
          });
        } else {
          if (response[0].per_type === "1" || response[0].per_type === "6") {
            this.setState({
              personAcuRegister: {
                per_id: response[0].per_id,
                per_name: response[0].per_name + ` ` + response[0].per_lastname,
              },
              loading: false,
              msg_error2: "",
            });
          } else {
            this.setState({
              msg_error2: "Esta cedula debe ser de un acudiente o profesor",
            });
          }
        }
      } else {
        this.setState({
          msg_error2: "No existe esta cedula",
        });
      }
    }
  }

  async fetchRegistrationYear() {
    const response = await getRegistrationYear();
    this.setState({
      registrationy: response,
      loading: false,
    });
  }

  async fetchSetup() {
    const response = await getSetup();
    this.setState({
      dataFormSetup: response,
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchSetup()
    this.fetchGrade();
    this.fetchRegistrationYear();
    this.fetchPersonList();
  }

  handlerChangeGrade() {
    const props = this.state.formChangeRegistration;
    const propsGrade = this.state.dataGradeSelected;
    const body = {
      reg_person: props.per_id,
      reg_grade: props.gr_id,
    };
    if(props.gr_id !== "0" && props.gr_id !== undefined ){
      putChangeGrade(body);
      this.setState({ isOpenModalChange: false });
    }


    setTimeout(() => {
      this.fetchRegistration({
        gr_id: propsGrade.gr_id,
        gr_desc: propsGrade.gr_desc,
      });
   }, 1000);
  }

   handlerOpenPerson =() =>{
    let history = useHistory();
    history.push("/parents/home");
    return null
  }

  handlerPutRegistration() {
    const props = this.state.formNewRegistration;
    const propsGrade = this.state.dataGradeSelected;

    const body = {
      reg_id:props.reg_id,
      reg_person:props.reg_peridEst,
      per_idacu:props.reg_peridAc,
      reg_testpsico: props.reg_testpsico,
      reg_photo: props.reg_photo,
      reg_certnac: props.reg_certnac,
      reg_certsalud: props.reg_certsal,
      reg_vacuna: props.reg_vacuna,
      reg_copyced: props.reg_copyced,
      reg_plegal: props.reg_plegal,
      reg_legalinfo: props.reg_legalinfo,
      re_cfirmado: props.re_cfirmado,
    };

    putRegister(body);
    this.setState({ isOpenModalAddRegistration: false,isOpenModalEditRegistration:false,loading:true });

    setTimeout(() => {
      this.fetchRegistration({
        gr_id: propsGrade.gr_id,
        gr_desc: propsGrade.gr_desc,
      });
    }, 1000);
  }

  handlerPostRegistration() {
    const props = this.state.formNewRegistration;
    const propsGrade = this.state.dataGradeSelected;
    const propsYear = this.state.registrationy;
    const propsPerson = this.state.personEstRegister;
    const propsPersonAcud = this.state.personAcuRegister;
    const propsSetup = this.state.dataFormSetup;
    var dataStartTrimestre;
    var dataEndTrimestre;
    var trimestre = propsSetup.set_trimestre;
    if (trimestre === "I") {
      dataStartTrimestre = propsSetup.set_start_ft;
      dataEndTrimestre = propsSetup.set_end_ft;
    } else if (trimestre === "II") {
      dataStartTrimestre = propsSetup.set_start_st;
      dataEndTrimestre = propsSetup.set_end_st;
    } else if (trimestre === "III") {
      dataStartTrimestre = propsSetup.set_start_tt;
      dataEndTrimestre = propsSetup.set_end_tt;
    }

    const body = {
      reg_person: propsPerson.per_id,
      per_idacu:propsPersonAcud.per_id,
      reg_year: propsYear.set_registrationy,
      reg_grade: propsGrade.gr_id,
      reg_testpsico: props.reg_testpsico,
      reg_photo: props.reg_photo,
      reg_certnac: props.reg_certnac,
      reg_certsalud: props.reg_certsal,
      reg_vacuna: props.reg_vacuna,
      reg_copyced: props.reg_copyced,
      reg_plegal: props.reg_plegal,
      reg_legalinfo: props.reg_legalinfo,
      re_cfirmado: props.re_cfirmado,
      date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
      date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
    };
   
    if(propsPersonAcud.per_id.length>0 && propsPersonAcud.per_name.length>0 && propsPerson.per_id.length>0 && propsPerson.per_name.length>0 && propsGrade.gr_id.length>0 && propsGrade.gr_id !== undefined &&  propsGrade.gr_id !=="0"){
        postNewRegister(body);
        this.setState({ isOpenModalAddRegistration: false,isOpenModalEditRegistration:false,loading:true,msg_error2:"" });
        setTimeout(() => {
          this.fetchRegistration({
            gr_id: propsGrade.gr_id,
            gr_desc: propsGrade.gr_desc,
          });
        }, 1000);
    }
    else{
      this.setState({ msg_error2:"El estudiante debe tener un acudiente"});
    }

  }

  handlerPutImport() {
    const props = this.state.formDataImport;
    const propsYear = this.state.registrationy;
    const propsGrade = this.state.dataGradeSelected;
    const propsSetup = this.state.dataFormSetup;
    var dataStartTrimestre;
    var dataEndTrimestre;
    var trimestre = propsSetup.set_trimestre;
    if (trimestre === "I") {
      dataStartTrimestre = propsSetup.set_start_ft;
      dataEndTrimestre = propsSetup.set_end_ft;
    } else if (trimestre === "II") {
      dataStartTrimestre = propsSetup.set_start_st;
      dataEndTrimestre = propsSetup.set_end_st;
    } else if (trimestre === "III") {
      dataStartTrimestre = propsSetup.set_start_tt;
      dataEndTrimestre = propsSetup.set_end_tt;
    }
    if (props.per_id.length > 0) {
      const body = {
        reg_person: props.per_id,
        per_idacu:props.per_acudiente,
        reg_complete: props.reg_complete,
        reg_testpsico: props.reg_testpsico,
        reg_photo: props.reg_photo,
        reg_certnac: props.reg_certnac,
        reg_certsalud: props.reg_certsal,
        reg_vacuna: props.reg_vacuna,
        reg_copyced: props.reg_copyced,
        reg_plegal: props.reg_plegal,
        reg_legalinfo: props.reg_legalinfo,
        re_cfirmado: props.re_cfirmado,
        reg_year: propsYear.set_registrationy,
        reg_grade: propsGrade.gr_id,
        date_week_start: moment(dataStartTrimestre).format("YYYY-MM-DD"),
        date_week_end: moment(dataEndTrimestre).format("YYYY-MM-DD"),
      };
      postNewRegister(body);
      this.setState({ isOpenModalImport: false, loading: true });

      setTimeout(() => {
        this.fetchRegistration({
          gr_id: propsGrade.gr_id,
          gr_desc: propsGrade.gr_desc,
        });
      }, 1000);
    } else {
      this.setState({
        msg_error: "Busca el estudiante por cedula",
      });
    }
  }

  handlePutRemoveRegister() {
    const props = this.state.formRemoveRegistration;
    const propsGrade = this.state.dataGradeSelected;
    if(props.per_id.length>0 && props.reg_reason){
      const body = {
        per_id: props.per_id,
        reg_id: props.reg_id,
        reg_reason: props.reg_reason,
      };
  
      putRemoveRegister(body);
      this.setState({ isOpenModalRemove: false });
    }
    else{
 this.setState({msg_error:"Debes escribir el motivo del retiro"})
    }

    setTimeout(() => {
      this.fetchRegistration({
        gr_id: propsGrade.gr_id,
        gr_desc: propsGrade.gr_desc,
      });
    }, 1000);
  }

  handleEditRegitration() {
    this.setState((prevState) => ({
      isOpenModalEditRegistration:!prevState.isOpenModalEditRegistration,
      msg_error:"",
      msg_error2:""

    }));
  }

  handleAddRegitration() {
    this.setState((prevState) => ({
      isOpenModalAddRegistration: !prevState.isOpenModalAddRegistration,
      isOpenModalEditRegistration:false,
      isOpenModalListaAcu:false,
      isOpenModalListaEst:false,
      msg_error: "",
      formNewRegistration: {
        reg_id:"",
        reg_peridEst: "",
        reg_cedulaEst: "",
        reg_nameEst: "",
        reg_peridAc: "",
        reg_cedulaAc: "",
        reg_nameAc: "",
        reg_testpsico: false,
        reg_photo: false,
        reg_certnac: false,
        reg_certsal: false,
        reg_vacuna: false,
        reg_copyced: false,
        reg_plegal: "0",
        reg_legalinfo: "",
        re_cfirmado: "0",
      },
      personEstRegister: {
        per_id: "",
        per_name: "",
      },
      personAcuRegister: {
        per_id: "",
        per_name: "",
      },
      msg_error2: "",
    }));
  }

  handleModalImport() {
    this.setState((prevState) => ({
      isOpenModalImport: !prevState.isOpenModalImport,
      formDataImport: {
        per_id: "",
        per_cedula: "",
        per_name: "",
        per_acudiente:"",
        reg_complete: "",
        reg_testpsico: "",
        reg_photo: "",
        reg_certnac: "",
        reg_certsal: "",
        reg_vacuna: "",
        reg_copyced: "",
        reg_plegal: "",
        reg_legalinfo: "",
        re_cfirmado: "",
        reg_oldyear: "",
        gr_id: "",
        gr_desc: "",
        gr_olddesc: "",
      },
      dataGradeImport:{
        gr_id:"",
        gr_desc:""
      },
      msg_error:"",
      dataStudent:[]
    }));
  }
 async fetchPersonToEditRegistration(reg_id:string){
  const response = await getPersonToEditRegistration(reg_id);
    this.setState({
      formNewRegistration: {
        reg_id:response[0].reg_id,
        reg_peridEst: response[0].reg_peridEst,
        reg_cedulaEst: response[0].reg_cedulaEst,
        reg_nameEst: response[0].reg_nameEst,
        reg_peridAc: response[0].reg_peridAc,
        reg_cedulaAc: response[0].reg_cedulaAc,
        reg_nameAc: response[0].reg_nameAc,
        reg_testpsico: response[0].reg_testpsico ==="1"? true: false,
        reg_photo: response[0].reg_photo ==="1"? true: false,
        reg_certnac: response[0].reg_certnac ==="1"? true: false,
        reg_certsal: response[0].reg_certsalud ==="1"? true: false,
        reg_vacuna: response[0].reg_vacuna ==="1"? true: false,
        reg_copyced: response[0].reg_copyced ==="1"? true: false,
        reg_plegal: response[0].reg_plegal,
        reg_legalinfo: response[0].reg_legalinfo,
        re_cfirmado: response[0].re_cfirmado,
      },
      dataGradeSelected:{
        gr_id:response[0].gr_id,
        gr_desc:response[0].gr_desc
      },
      registrationy: {
        set_registrationy:response[0].reg_year,
      },
      personEstRegister:{
        per_id: response[0].reg_peridEst,
        per_name: response[0].reg_nameEst,
      },
      personAcuRegister:{
        per_id: response[0].reg_peridAc,
        per_name: response[0].reg_nameAc,
      },
      isOpenModalEditRegistration:true
    });
  }

  handlerDataEditRegistration = (row: any) => {
   this.fetchPersonToEditRegistration(row.reg_id)

  };

  editRegistration(cell:any, row:any) {
    return (
      <React.Fragment>
        <Row>
          <Col xs={12} className="d-flex">
            <Label className="txt-underline" onClick={() => this.handlerDataEditRegistration(row)}>
              {row.per_cedula}
            </Label>
            <img className="img-status img-search" onClick={() => this.handlerDataEditRegistration(row)} src={PENCIL} alt="" />
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  handleModalChange(row: IRegistration) {
    const props = this.state.dataGradeSelected;
    this.setState((prevState) => ({
      isOpenModalChange: !prevState.isOpenModalChange,
      formChangeRegistration: {
        per_id: row.per_id,
        per_name: row.per_name,
        per_lastname: row.per_lastname,
        per_cedula: row.per_cedula,
        gr_id: props.gr_id,
        gr_desc: props.gr_desc,
      },
    }));
  }

  handleModalRemove(row: IRegistration) {
    this.setState((prevState) => ({
      isOpenModalRemove: !prevState.isOpenModalRemove,
      formRemoveRegistration: {
        reg_id: row.reg_id,
        per_id: row.per_id,
        per_name: row.per_name,
        per_lastname: row.per_lastname,
        per_cedula: row.per_cedula,
        reg_reason: "",
      },
      msg_error:""
    }));
  }

  onChangeRemoveRegister(e: any) {
    this.setState({
      formRemoveRegistration: {
        ...this.state.formRemoveRegistration,
        [e.target.name]: e.target.value,
      },
    });
  }

  onChangeNewRegistration(e: any) {
    this.setState({
      formNewRegistration: {
        ...this.state.formNewRegistration,
        [e.target.name]: e.target.value,
      },
      msg_error2:"",
      msg_error:""
    });
  }

  onChangeImportRegistration(e: any) {
    this.setState({
      formDataImport: {
        ...this.state.formDataImport,
        [e.target.name]: e.target.value,
      },
      msg_error:""
    });
  }

  onChangeNewRegistrationCheck(e: any) {
    this.setState({
      formNewRegistration: {
        ...this.state.formNewRegistration,
        [e.target.name]: e.target.checked,
      },
    });
  }

  async studentHandleSelected(row, isSelect) {
    const props = row;
    const response = await getPersonByCedulaImport(props.per_cedula);
    if (response.matriculado === "si") {
      this.setState({
        msg_error: props.per_cedula + " ya esta matriculado",
        formDataImport: {
          per_id: "",
          per_cedula: "",
          per_name: "",
          per_acudiente:"",
          reg_complete: "",
          reg_testpsico: "",
          reg_photo: "",
          reg_certnac: "",
          reg_certsal: "",
          reg_vacuna: "",
          reg_copyced: "",
          reg_plegal: "",
          reg_legalinfo: "",
          re_cfirmado: "",
          reg_oldyear: "",
          gr_id: "",
          gr_desc: "",
          gr_olddesc: "",
        },
        loading: false,
      });
    } else {
      if (response.existe !== "no") {
        this.setState({
          formDataImport: {
            per_id: response[0].per_id,
            per_cedula: response[0].per_cedula,
            per_name: response[0].per_name,
            per_acudiente:response[0].per_acudiente,
            reg_complete: response[0].reg_complete,
            reg_testpsico: response[0].reg_testpsico,
            reg_photo: response[0].reg_photo,
            reg_certnac: response[0].reg_certnac,
            reg_certsal: response[0].reg_certsalud,
            reg_vacuna: response[0].reg_vacuna,
            reg_copyced: response[0].reg_copyced,
            reg_plegal: response[0].reg_plegal,
            reg_legalinfo: response[0].reg_legalinfo,
            re_cfirmado: "0",
            reg_oldyear: response[0].reg_year,
            gr_id: response[0].gr_id,
            gr_desc: response[0].gr_desc,
            gr_olddesc: response[0].gr_desc,
          },
          loading: false,
          msg_error: "",
        });
      } else {
        this.setState({
          msg_error: "No existe estudiante con esa cedula",
        });
      }
    }
  }

  registrationHandleOptions = (cell: number, row: IRegistration) => (
    <Row>
      <Col sm={6}>
        <Button color="success" className="w-100" onClick={() => this.handleModalChange(row)}>
          Cambiar
        </Button>
      </Col>
      <Col sm={6}>
        <Button color="danger" className="w-100" onClick={() => this.handleModalRemove(row)}>
          Retirar
        </Button>
      </Col>
    </Row>
  );

  setGradeChanged = (gr_desc: string, gr_id: string) => {
    this.setState({
      formChangeRegistration: {
        ...this.state.formChangeRegistration,
        gr_id,
        gr_desc,
      },
    });
  };

  setGradeChangedImport = (gr_desc: string, gr_id: string) => {
    this.setState({
      dataGradeImport: {
        ...this.state.dataGradeImport,
        gr_id,
        gr_desc,
      },
    });

    this.getRegistrationLastYearByGrade(gr_id);
  };

  setProcess = (reg_plegal: string) => {
    this.setState({
      formNewRegistration: {
        ...this.state.formNewRegistration,
        reg_plegal,
      },
    });
  };

  setContract = (re_cfirmado: string) => {
    this.setState({
      formNewRegistration: {
        ...this.state.formNewRegistration,
        re_cfirmado,
      },
    });
  };

  setContractImport = (re_cfirmado: string) => {
    this.setState({
      formDataImport: {
        ...this.state.formDataImport,
        re_cfirmado,
      },
    });
  };

  rechargeData() {
    const propsGrade = this.state.dataGradeSelected;
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchRegistration({
        gr_id: propsGrade.gr_id,
        gr_desc: propsGrade.gr_desc,
      });
    }, 1000);
  }

  handlerOpenLista() {
    this.setState((prevState) => ({
      isOpenModalListaEst: !prevState.isOpenModalListaEst,
    }));
  }

  handlerOpenListaAcu() {
    this.setState((prevState) => ({
      isOpenModalListaAcu: !prevState.isOpenModalListaAcu,
    }));
  }


  handlerSetPerson(row: any) {
    const props = this.state;
    if(props.isOpenModalListaEst){
      this.setState({
        formNewRegistration:{
          ...this.state.formNewRegistration,
          reg_cedulaEst:row.per_cedula
        },
        isOpenModalListaEst: false,
        isOpenModalListaAcu:false
      });
    }
    else{
      this.setState({
        formNewRegistration:{
          ...this.state.formNewRegistration,
          reg_cedulaAc:row.per_cedula
        },
        isOpenModalListaEst: false,
        isOpenModalListaAcu:false
      });
    }
  }

  setPerson(cell, row) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Button className="txt-underline w-100" onClick={() => this.handlerSetPerson(row)}>
            Selecionar
          </Button>
        </Col>
      </Row>
    );
  }

  render() {
    const props = this.state;
    const selectRosw = {
      mode: "checkbox",
      clickToSelect: true,
      onSelect: this.studentHandleSelected,
      hideSelectColumn: true,
    };
    return (
      <React.Fragment>
        {props.isOpenModalListaEst && (
          <ModalListaPerson
            dataPerson={props.dataPersonEstudiante}
            setPerson={this.setPerson}
            toggleClose={this.handlerOpenLista}
            isOpen={props.isOpenModalListaEst}
            title="Selecionar estudiante"
          />
        )}

        {props.isOpenModalListaAcu && (
          <ModalListaPerson
            dataPerson={props.dataPersonAcudiente}
            setPerson={this.setPerson}
            toggleClose={this.handlerOpenListaAcu}
            isOpen={props.isOpenModalListaAcu}
            title="Selecionar Acudiente"
          />
        )}

        {props.isOpenModalAddRegistration && (
          <AdminModalRegistration
            title="Nueva matricula"
            msg_error={props.msg_error}
            msg_error2={props.msg_error2}
            dataGradoSelected={props.dataGradeSelected}
            dataFRegistration={props.formNewRegistration}
            dataEstName={props.personEstRegister}
            dataAcName={props.personAcuRegister}
            propY={props.registrationy}
            isOpen={props.isOpenModalAddRegistration}
            toggle={this.handleAddRegitration}
            searchEstudent={this.fetchPersonEst}
            searchAcu={this.fetchPersonAc}
            toggleSave={this.handlerPostRegistration}
            setDataRegistration={this.onChangeNewRegistrationCheck}
            onChangeNewRegistration={this.onChangeNewRegistration}
            setProcess={this.setProcess}
            setContract={this.setContract}
            isEditing={false}
            handlerOpenLista={this.handlerOpenLista}
            handlerOpenListaAcudiente = {this.handlerOpenListaAcu}
            handlerOpenPerson = {this.handlerOpenPerson}
          />
        )}
        {props.isOpenModalEditRegistration && (
          <AdminModalRegistration
            title="Editar matricula"
            msg_error={props.msg_error}
            msg_error2={props.msg_error2}
            dataGradoSelected={props.dataGradeSelected}
            dataFRegistration={props.formNewRegistration}
            dataEstName={props.personEstRegister}
            dataAcName={props.personAcuRegister}
            propY={props.registrationy}
            isOpen={props.isOpenModalEditRegistration}
            toggle={this.handleEditRegitration}
            searchEstudent={this.fetchPersonEst}
            searchAcu={this.fetchPersonAc}
            toggleSave={this.handlerPutRegistration}
            setDataRegistration={this.onChangeNewRegistrationCheck}
            onChangeNewRegistration={this.onChangeNewRegistration}
            setProcess={this.setProcess}
            setContract={this.setContract}
            isEditing={true}
            handlerOpenLista={this.handlerOpenLista}
            handlerOpenListaAcudiente = {this.handlerOpenListaAcu}
          />
        )}

        {props.isOpenModalImport && (
          <AdminModalImport
            dataGradeSelected={props.dataGradeImport}
            dataGrades={props.dataGrades}
            dataStuden={props.dataStudent}
            optionSelectRow={selectRosw}
            searchEstudent={this.fetchPersonEstImport}
            setCeducativo={this.setContractImport}
            msg_error={props.msg_error}
            onChangeImportRegistration={this.onChangeImportRegistration}
            dataFRegistrationImport={props.formDataImport}
            isOpen={props.isOpenModalImport}
            toggle={this.handleModalImport}
            toggleSave={this.handlerPutImport}
            setGradeChanged={this.setGradeChangedImport}
          />
        )}

        {props.isOpenModalChange && (
          <AdminModalChangeGrade
            dataPersonSelected={props.formChangeRegistration}
            dataGrades={props.dataGrades}
            isOpen={props.isOpenModalChange}
            toggle={this.handleModalChange}
            setGradeChanged={this.setGradeChanged}
            toggleSave={this.handlerChangeGrade}
          />
        )}
        {props.isOpenModalRemove && (
          <AdminModalRemoveStudent
            dataPersonSelected={props.formRemoveRegistration}
            isOpen={props.isOpenModalRemove}
            toggle={this.handleModalRemove}
            setGradeChanged={this.setGradeChanged}
            toggleConfirm={this.handlePutRemoveRegister}
            onChange={this.onChangeRemoveRegister}
            msg_error={props.msg_error}
          />
        )}
        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row className="body-margin">
                <Col sm={12} className="text-center">
                  <Label className="font-weight-bold">
                    <h3>Matricula</h3>
                    <br></br>
                    <h3> {props.registrationy.set_registrationy}</h3>
                  </Label>
                </Col>
                <Col sm={12}>
                  <DatatableExpand
                    data={props.dataGrades}
                    columns={COLUMNS_GRADES()}
                    keyProp="gr_id"
                    expandRow={EXPAND_ROW_GRADE(
                      props.loading,
                      this.rechargeData,
                      this.fetchRegistration,
                      props.dataRegistration,
                      this.handleModalImport,
                      this.handleAddRegitration,
                      this.editRegistration,
                      this.registrationHandleOptions,
                    
                    )}
                    exportD={false}
                    searchs={false}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Registration;
